"use client";
import { useState } from "react";
const faqs = [
    {
        question: "What orthopedic services are available at HDNA Aarogyam Hospital?",
        answer: "We provide comprehensive orthopedic care including joint replacement surgery (knee & hip), arthroscopy, sports injury treatment, fracture & trauma care, spine treatment, pediatric orthopedics, and rehabilitation services.",
    },
    {
        question: " When should I consider knee or hip replacement surgery?",
        answer: "Joint replacement is recommended when chronic pain, stiffness, and reduced mobility due to arthritis or joint degeneration do not improve with medication, physiotherapy, or lifestyle changes.",
    },
    {
        question: "What types of joint replacement surgeries are performed at HDNA Aarogyam Hospital?",
        answer: "We offer Total Knee Replacement (TKR), Partial Knee Replacement, Total Hip Replacement (THR), and Revision Joint Replacement surgeries using advanced implant systems and minimally invasive techniques.",
    },
    {
        question: "How long does recovery take after knee replacement surgery?",
        answer: "Most patients begin walking within a few days after surgery. Full recovery typically takes 6–12 weeks, depending on individual health, physiotherapy participation, and overall fitness",
    },
    {
        question: "Is joint replacement surgery safe?",
        answer: "Yes, joint replacement is a safe and commonly performed procedure when done by experienced orthopedic surgeons. We follow strict safety protocols, advanced surgical planning, and post-operative monitoring to minimize risks.",
    },
    {
        question: "Do you provide minimally invasive orthopedic surgeries?",
        answer: "Yes, we use minimally invasive techniques whenever suitable. These procedures involve smaller incisions, reduced blood loss, less pain, and faster recovery.",
    },
    {
        question: "What treatments are available for sports injuries?",
        answer: "We provide arthroscopic surgery for ligament tears, meniscus injuries, shoulder instability, and other sports-related conditions, along with structured rehabilitation programs for faster return to activity.",
    },
    {
        question: "Is emergency fracture and trauma care available?",
        answer: "Yes, our orthopedic department offers 24/7 emergency trauma and fracture care with advanced imaging and surgical fixation facilities.",
    },
    {
        question: "What rehabilitation services are available after surgery?",
        answer: "Our integrated physiotherapy and rehabilitation programs focus on mobility restoration, muscle strengthening, pain management, and faster recovery under expert supervision.",
    },
    {
        question: "How can I book an appointment for orthopedic consultation in Patna?",
        answer: "You can schedule a consultation by calling our hospital, visiting the facility in Patna, or booking an appointment online through our official website.",
    }
]
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
